// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GraphContainer__container___SE7M_ {
    display: grid;
    grid-template:
        'yLabelLeft graph  yLabelRight' auto
        'empty1     xLabel empty2     ' 1.8rem
        / 1.8rem auto 1.8rem;
    gap: var(--space-2xs) var(--space-m);

    height: 100%;
    padding: var(--space-2xs);
}

.GraphContainer__withoutRight___YHGh3 {
    grid-template:
        'yLabelLeft graph ' auto
        'empty      xLabel' 1.8rem
        / 1.8rem auto;
}

.GraphContainer__xLabel___EZAQV {
    grid-area: xLabel;
    justify-self: center;
}

.GraphContainer__yLabelLeft___fdxjp {
    rotate: 180deg;
    grid-area: yLabelLeft;
    align-self: center;
    writing-mode: vertical-rl;
}

.GraphContainer__yLabelRight___G4t1g {
    grid-area: yLabelRight;
    align-self: center;
    writing-mode: vertical-rl;
    text-align: center;
}

.GraphContainer__graph___EzYpq {
    display: flex;
    grid-area: graph;

    & > * {
        flex: 1;

        width: 0;
        min-width: 100%;
        height: 0;
        min-height: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/GraphContainer/GraphContainer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb;;;4BAGwB;IACxB,oCAAoC;;IAEpC,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI;;;qBAGiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;;IAEhB;QACI,OAAO;;QAEP,QAAQ;QACR,eAAe;QACf,SAAS;QACT,gBAAgB;IACpB;AACJ","sourcesContent":[".container {\n    display: grid;\n    grid-template:\n        'yLabelLeft graph  yLabelRight' auto\n        'empty1     xLabel empty2     ' 1.8rem\n        / 1.8rem auto 1.8rem;\n    gap: var(--space-2xs) var(--space-m);\n\n    height: 100%;\n    padding: var(--space-2xs);\n}\n\n.withoutRight {\n    grid-template:\n        'yLabelLeft graph ' auto\n        'empty      xLabel' 1.8rem\n        / 1.8rem auto;\n}\n\n.xLabel {\n    grid-area: xLabel;\n    justify-self: center;\n}\n\n.yLabelLeft {\n    rotate: 180deg;\n    grid-area: yLabelLeft;\n    align-self: center;\n    writing-mode: vertical-rl;\n}\n\n.yLabelRight {\n    grid-area: yLabelRight;\n    align-self: center;\n    writing-mode: vertical-rl;\n    text-align: center;\n}\n\n.graph {\n    display: flex;\n    grid-area: graph;\n\n    & > * {\n        flex: 1;\n\n        width: 0;\n        min-width: 100%;\n        height: 0;\n        min-height: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GraphContainer__container___SE7M_`,
	"withoutRight": `GraphContainer__withoutRight___YHGh3`,
	"xLabel": `GraphContainer__xLabel___EZAQV`,
	"yLabelLeft": `GraphContainer__yLabelLeft___fdxjp`,
	"yLabelRight": `GraphContainer__yLabelRight___G4t1g`,
	"graph": `GraphContainer__graph___EzYpq`
};
export default ___CSS_LOADER_EXPORT___;
